import { JSX, useState } from 'react';
import {
    Create,
    useCreate,
    SimpleForm,
    NumberInput,
    SelectInput,
    useNotify,
    useRefresh,
    BooleanInput
} from 'react-admin';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Button
} from '@mui/material';
import {
    Close as CloseIcon,
    Add as AddIcon
} from '@mui/icons-material';
import { SubscriptionProduct } from "../../../../types/entities";
import { currency, frequency } from "../../../../defaults/defaults";
import { ChatFieldBridge } from "../../../chat-bot/components/ChatFieldBridge";

export const SubscriptionProductNewPriceModal: (props: any) => JSX.Element = (props: any): JSX.Element => {
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [create] = useCreate();
    const notify: any = useNotify();
    const refresh: any = useRefresh();
    const record: SubscriptionProduct = props.record;

    function handleClose(): void {
        setOpenModal(false);
    }

    function handleOpen(): void {
        setOpenModal(true);
    }

    function handleSubmit(values: any): void {
        if (record) {
            values.subscriptionProduct = record.id
            values.name = "Price for " + record.name;
            create(
                'subscription_product_prices',
                {
                    data: values
                },
                {
                    onSuccess: async (data: any): Promise<void> => {
                        refresh();
                        notify("New price created successfully!", { type: "success" });
                        handleClose();
                    },
                    onError: (error: any): void => {
                        let errorMessage: string;
                        if (typeof error === 'string') {
                            errorMessage = error;
                        } else {
                            errorMessage = error.message;
                        }

                        notify(`Failed to create error: ${errorMessage}`, { type: 'error' });
                    },
                }
            )
        }
    }

    return (
        <>
            <Button variant='contained' onClick={ handleOpen } >
                { "Add New Price" }
                <AddIcon />
            </Button>
            <Dialog
                maxWidth="lg"
                fullWidth
                open={ openModal }
                onClose={ handleClose }>
                <DialogTitle>
                    <div style={ { width: '100%', display: 'flex', justifyContent: 'space-between' } }>
                        <span>{ "Add Price To " + record?.name }</span>
                        <button type="button"
                                onClick={ handleClose }
                                style={ { cursor: 'pointer' } }>
                            <CloseIcon />
                        </button>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <Create resource="subscription_product_prices" title=" ">
                        <SimpleForm onSubmit={ handleSubmit }>
                            <NumberInput source="price" name="price" />
                            <SelectInput source="currency" name="currency" choices={ currency } />
                            <NumberInput source="priceFrequencyCount"
                                         name="priceFrequencyCount"
                                         defaultValue={1} />
                            <SelectInput source="priceFrequency"
                                         name="priceFrequency"
                                         defaultValue="month"
                                         choices={ frequency } />
                            <BooleanInput source="active" name="active" />
                            <BooleanInput source="defaultPrice" name="defaultPrice" />
                            { /* Offers this modal to the assistant. Renders nothing, writes nothing by
                                 itself. HQ-12: the registry is a stack now, so this no longer displaces
                                 the page form underneath. */ }
                            <ChatFieldBridge />
                        </SimpleForm>
                    </Create>
                </DialogContent>
            </Dialog>
        </>
    );
}